export const token = {
  isLoggedIn () {
    return Boolean(sessionStorage.dicicilUser)
  },
  clear () {
    sessionStorage.removeItem('dicicilAccessToken')
    sessionStorage.removeItem('dicicilAccessTokenType')
    sessionStorage.removeItem('dicicilRefreshToken')
  },
  set accessToken (token) {
    sessionStorage.setItem('dicicilAccessToken', token)
  },
  get accessToken () {
    return sessionStorage.getItem('dicicilAccessToken')
  },
  set accessTokenType (tokenType) {
    sessionStorage.setItem('dicicilAccessTokenType', tokenType)
  },
  get accessTokenType () {
    return sessionStorage.getItem('dicicilAccessTokenType')
  },
  set refreshToken (token) {
    sessionStorage.setItem('dicicilRefreshToken', token)
  },
  get refreshToken () {
    return sessionStorage.getItem('dicicilRefreshToken')
  },
}